import { Company, Rib } from 'src/types/data';

/**
 * Add a new RIB to the company's list of ribs.
 */
export const addRib = (companies: Company[], companyId: number, newRib: Rib): Company[] => 
  companies.map((company) =>
    company.id === companyId
      ? { ...company, ribs: [newRib, ...company.ribs] }
      : company
  );

/**
 * Update an existing RIB within the company's list of ribs.
 */
export const updateRib = (companies: Company[], companyId: number, updatedRib: Rib): Company[] => 
   companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.map((rib) =>
            rib.id === updatedRib.id ? { ...rib, ...updatedRib } : rib
          ),
        }
      : company
  );

/**
 * Remove a RIB from the company's list of ribs.
 */
export const removeRib = (companies: Company[], companyId: number, ribId: number): Company[] => 
   companies.map((company) =>
    company.id === companyId
      ? {
          ...company,
          ribs: company.ribs.filter((rib) => rib.id !== ribId),
        }
      : company
  );
